import httpService from "@/helper/httpService";
import { productKeyFromCategories } from "@/helper/praemienHelper";
import iban from "iban";
import bic from "bic";

export const loginNameRule = {
  getMessage() {
    return "Der Anmeldename ist nicht verfügbar.";
  },
  validate(value) {
    return httpService.checkUserName(value)
      .then(response => response.available)
      // TODO true or false for error? different message?
      .catch(() => false);
  }
};

export const allowedCategoriesRule = {
  getMessage() {
    return "Ungültige Kombination für ihren Tarif.";
  },
  validate(value, args) {
    if (!args || !args[0]) {
      return true;
    }
    const tarif = args[0];
    const productKey = productKeyFromCategories(value);
    switch (tarif) {
      case "comfortplan":
        return ["PBVW", "PBW", "PVW", "PBV"].includes(productKey);
      case "securo":
        return ["PBVW", "PBV", "V"].includes(productKey);
      case "securoplus":
        return productKey !== "P";
      case "securopremium":
        return ["PBVW", "PVW", "PBV"].includes(productKey);
      default:
        return true;
    }
  }
};

export const truthyRule = {
  getMessage: field => field + ' ist ein Pflichtfeld.',
  validate: value => !!value
};

export const ibanRule = (value) => {
  return iban.isValid(value.replace(/ /g,""));
};

export const bicRule = (value) => {
  return bic.isValid(value);
};